module.exports = __webpack_public_path__ + "media/images/teacher/total-courses-59125aea0e869ed7aa63b48d1083867d.png";